// @ts-nocheck
import { __INITIAL_STATE__TYPE } from '../global';

const getFeatureFlag = (featureFlagName: string) => {
  if (typeof window === 'undefined') {
    return false;
  }

  const rawInitialState: __INITIAL_STATE__TYPE = window.__INITIAL_STATE_UNPARSED__
    ? JSON.parse(window.__INITIAL_STATE_UNPARSED__)
    : window.__INITIAL_STATE__ || {};

  const featureFlags = rawInitialState.feature_flags;
  const feature = featureFlags
    ? featureFlags.find(f => f.key === featureFlagName)
    : undefined;

  const isFeatureFlagEnable = !!(feature && feature.is_active);

  return isFeatureFlagEnable;
};

export default getFeatureFlag;
